import styled from 'styled-components';

const LinkedElement = styled.div`
  padding-left: ${(props): string => props.theme.spaces.md};
  padding-right: ${(props): string => props.theme.spaces.md};
  color: ${(props): string => props.theme.colors.spaceBlack};
  flex-grow: 0;
`;

export { LinkedElement };
